



























































import { Component, Vue, Prop } from 'vue-property-decorator'
import ToastAlert from '@/components/Toast.vue'
import { SettingsSubmissionResponse, WorkspaceUser } from '@/views/WorkspaceSettings.vue'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import { Icon } from '@alpha/ink'
import DropdownButton from '@/components/DropdownButton.vue'
import _ from 'lodash'
import LoaderImg from '@/assets/img/loading.gif'
import store from '@/store'

type ToggleablePermission = 'basic_user'|'workspace_admin'

@Component({
  name: 'ManageUsers',
  components: { AjaxButton, SettingsCard, ToastAlert, Icon, DropdownButton }
})
export default class ManageUsers extends Vue {
  @Prop({ required: true }) workspaceUsers!:WorkspaceUser[]
  @Prop({ required: true }) workspaceId!:string
  @Prop({ required: true }) isAlphaAdmin!:boolean

  manageUsers = {
    currentPage: 0
  }

  toast: boolean|string = false
  submitting: boolean|string = false
  loaderImg: string = LoaderImg

  get filteredUsers () {
    let filtered = this.isAlphaAdmin ? this.workspaceUsers : this.workspaceUsers.filter(user => user.payload.permissions[this.workspaceId] !== 'alpha_admin')
    filtered = filtered.map((user) => {
      let isOrganization = false
      Object.keys(user.payload.permissions).forEach((id) => {
        if (id === store.state.workspace.workspace.payload.organization.id && user.payload.permissions[id] === 'organization_admin') {
          isOrganization = true
        }
      })

      if (isOrganization) user.type = 'organization_admin'
      return user
    })

    filtered = _.sortBy(filtered, [function (o) { return [o.payload.firstname && o.payload.firstname.toLowerCase(), o.payload.lastname ? o.payload.lastname.toLowerCase() : ''] }])
    return filtered
  }

  get currentPageUsers () {
    // const start = this.manageUsers.currentPage * 20
    // const end = start + 20
    // return this.filteredUsers.slice(start, end)
    return this.filteredUsers
  }

  get maxPages () {
    return Math.ceil(this.filteredUsers.length / 20)
  }

  submit (section: 'permissions'|'remove', user: WorkspaceUser, permission: ToggleablePermission) {
    if (!this.submitting) {
      this.submitting = user.id
      var submitObj = {
        component: this,
        section: section,
        data: {
          uid: user.id,
          permissions: permission
        }
      }
      this.$emit('submit', submitObj)
      // workaround to simulate a click outside
      // TODO: Update dropdownbutton with a way to handle this properly
      document.body.click()
    }
  }

  finish (confirmation: SettingsSubmissionResponse) {
    var that = this
    this.toast = confirmation.msg
    this.submitting = false
    if (confirmation.status !== 'failure') {
      setTimeout(function () {
        that.toast = false
      }, 3000)
    }
  }

  userPermission (user: WorkspaceUser) {
    const { permissions } = user.payload
    if (user.type === 'organization_admin') return user.type
    return permissions[this.workspaceId]
  }

  formatUserName (user: WorkspaceUser) {
    let fullName = ''
    const firstName = user.payload.firstname
    const lastName = user.payload.lastname
    if (firstName) {
      fullName += firstName
    }
    if (lastName) {
      fullName += ' ' + lastName
    }
    return fullName
  }

  formatUserStatus (status: string): string {
    switch (status) {
      case 'workspace_admin':
        return 'Workspace Administrator'
      case 'organization_admin':
        return 'Organization Administrator'
      case 'basic_user':
        return 'User'
      case 'alpha_admin':
        return 'Feedback Loop Admin'
      default:
        return ''
    }
  }

  clickCallback (page: number) {
    this.manageUsers.currentPage = page - 1
  }

  toggleAdmin (user: WorkspaceUser, $event: any, targetPermission: ToggleablePermission) {
    user.payload.permissions[this.workspaceId] = targetPermission
    this.submit('permissions', user, targetPermission)
  }

  removeUser (user: WorkspaceUser, $event: any, targetPermission: ToggleablePermission) {
    if (confirm('Are you sure you want to remove this user from your workspace? This action cannot be undone.')) {
      this.submit('remove', user, targetPermission)
      // TODO: does not actually wait for success
      this.$nextTick(function () {
        this.$emit('remove-user', user.id)
      })
    }
  }
}
